$(function() {
	// // Main Homepage Slider
	// $('.main-slider').bxSlider({
		
	// });
	// Product Slider
	$('.slider').bxSlider({
		auto: 'true',
		slideMargin: '10',
		infiniteLoop: 'true',
		useCSS: 'false',  
		touchEnabled: 'false'
	});
	//Sale Notifier on home page below navigation
	//$( ".ship-note-wrap .close" ).click(function() {
	//	$( ".ship-note-wrap" ).slideUp();
	//});
	//$('input:checkbox').screwDefaultButtons({
	//	image: "url({{ '_action-check-p-2.png' | asset_url }})",
	//	width: 36,
	//	height: 36
	//});
  	// Hide Checkbox without JS
  	$('.styledcheckbox_basic').addClass('styledcheckbox_basic_show');
  	$('.service_hidenojs').removeClass('service_hidenojs');
	// Selected Filter Tags 
	$(".tag-del").mouseover(function(){
		$(this).siblings(".tag-selected").addClass("seleced-hover");
	});
	$(".tag-del").mouseleave(function(){
		$(".tag-selected").removeClass("seleced-hover");
	});
	// Look for Quantity Break Pricing div and check if it has anyhing inside
	// If True, display .show-case div 
	setTimeout(function() {
		// console.log($('.shappify_qb_grid').text().length);
    	if ($('.shappify_qb_grid').text().length > 0) {
    		$(".tennis-case").addClass("show-case");
		} else {
			$(".tennis-case").removeClass("show-case");
		}
	}, 1000);
	/* PDP accordion: instant open/close; smooth scroll so prior section header stays visible below sticky bar (not only the active one). */
	function motPdpPrevAccordionHeader(headerEl) {
		if (!headerEl || !headerEl.previousElementSibling) return null;
		var el = headerEl.previousElementSibling;
		while (el) {
			if (el.classList && (el.classList.contains('ui-accordion-header') || el.classList.contains('accord-title'))) {
				return el;
			}
			el = el.previousElementSibling;
		}
		return null;
	}
	var motPdpAccordionOptions = {
		collapsible: true,
		active: 0, /* Description — matches desktop tabs default (first panel) */
		heightStyle: 'content',
		animate: false,
		activate: function (event, ui) {
			if (!ui.newHeader.length) return;
			var scrollFn = window.motScheduleScrollToBelowHeader;
			if (typeof scrollFn !== 'function') return;
			var h = ui.newHeader[0];
			var anchor = motPdpPrevAccordionHeader(h) || h;
			scrollFn(anchor, 0);
		}
	};
	// Product accordion: initialized AFTER spec/fit/tech DOM moves (see accordionMaker() call below).
	var accordionMaker = function() {
		if (!$('.prodInfoAccordion').length) return;
		$('.prodInfoAccordion').accordion(motPdpAccordionOptions);
	};
	// Opens stringing Options Modal if checkbox is checked
	$('#stringservice').change(function () {
        if ($(this).is(':checked')) {
          	$("#bundle_id").insertAfter("#bundleIN");
            $("#ASRC_id").insertAfter("#bundleIN");
            $(".stringing-options-modal").addClass('showModal');
          	$("#wishlist_wrap").addClass('hide_wrap');
          	$("#demo_wrap").addClass('hide_wrap');
        } else {
          	$("#bundle_id").insertAfter("#bundleOUT");
            $("#ASRC_id").insertAfter("#bundleOUT");
 			$(".stringing-options-modal").removeClass('showModal');
          	$("#wishlist_wrap").removeClass('hide_wrap');
          	$("#demo_wrap").removeClass('hide_wrap');
        }
    });
  	$('#giftwithpurchase').change(function () {
        if ($(this).is(':checked')) {
          	$("#gift_id").insertAfter("#bundleIN");            
        } else {
          	$("#gift_id").insertAfter("#bundleOUT");            
        }
    });
  	$('#promowithpurchase').change(function () {
        if ($(this).is(':checked')) {
          	$("#promo_id").insertAfter("#bundleIN");
        } else {
          	$("#promo_id").insertAfter("#bundleOUT");
        }
    });
    $('#coverwithpurchase').change(function () {
        if ($(this).is(':checked')) {
          	$("#cover_id").insertAfter("#bundleIN");
        } else {
          	$("#cover_id").insertAfter("#bundleOUT");
        }
    });
  	$('#giftwrapservice').change(function () {
        if ($(this).is(':checked')) {
          	$("#gift_wrapping").insertAfter("#bundleIN");
          	$("#gift_wrapping_id").insertAfter("#bundleIN");
        } else {
          	$("#gift_wrapping").insertAfter("#bundleOUT");
          	$("#gift_wrapping_id").insertAfter("#bundleOUT");
        }
    });
    $(".stringing-options-content .cancel-ss").click(function() {
		//Closes Modal
		$(".stringing-options-modal").removeClass('showModal');
		//Unchecks Stringing Service checkbox if cancel is clicked
		$('#stringservice').prop('checked', false);
		if (typeof window.motSyncAddonToggleCheckedLabel === 'function') {
			window.motSyncAddonToggleCheckedLabel(document.getElementById('stringservice'));
		}
		//Screw Defalt Styles Fix for unchecked checkbox
		$('#stringservicebox .styledCheckbox').css('background-position', '0px 0px');
	});
	$(".stringing-options-content .atc-ss").click(function() {
		//Closes Modal
		$(".stringing-options-modal").removeClass('showModal');
	});
	// Moves spec tables from Description into Specifications after Liquid-output UL (prod_spec is split in Liquid).
	var specExtractor = function() {
		var $tabs = $(".prodInfoTabs #description table");
		var $anchorTabs = $(".prodInfoTabs #specifications .pdp-spec-ul-liquid");
		if (!$anchorTabs.length) {
			$anchorTabs = $(".prodInfoTabs .spec-insert");
		}
		if ($anchorTabs.length && $tabs.length) {
			$tabs.insertAfter($anchorTabs);
		}
		var $acc = $(".prodInfoAccordion #description-acc table");
		var $anchorAcc = $(".prodInfoAccordion #specifications-acc .pdp-spec-ul-liquid");
		if (!$anchorAcc.length) {
			$anchorAcc = $(".prodInfoAccordion .spec-insert-2");
		}
		if ($anchorAcc.length && $acc.length) {
			$acc.insertAfter($anchorAcc);
		}
	};
	specExtractor();
	// If Liquid didn’t strip prod_spec / prod_tech (non-canonical tags or div wrappers), move from description into panels.
	var pdpSpecTechFallback = function() {
		var $tDesc = $(".prodInfoTabs #description");
		var $aDesc = $(".prodInfoAccordion #description-acc");
		var $tSpec = $(".prodInfoTabs #specifications .pdp-spec-ul-liquid");
		var $aSpec = $(".prodInfoAccordion #specifications-acc .pdp-spec-ul-liquid");
		var $tTech = $(".prodInfoTabs #technology .pdp-tech-ul-liquid");
		var $aTech = $(".prodInfoAccordion #technology-acc .pdp-tech-ul-liquid");
		if ($tSpec.length && $tDesc.find(".prod_spec").length) {
			$tDesc.find(".prod_spec").appendTo($tSpec);
		}
		if ($aSpec.length && $aDesc.find(".prod_spec").length) {
			$aDesc.find(".prod_spec").appendTo($aSpec);
		}
		if ($tTech.length && $tDesc.find(".prod_tech").length) {
			$tDesc.find(".prod_tech").appendTo($tTech);
		}
		if ($aTech.length && $aDesc.find(".prod_tech").length) {
			$aDesc.find(".prod_tech").appendTo($aTech);
		}
	};
	pdpSpecTechFallback();

  	// Moves Extra Fit Info to Fit Guide tab
	var ulFITExtractor = function() {
		$(".prodInfoTabs #description .prod_fit").insertAfter(".fit-insert");
	};
      if ($(".prod_fit")[0]) {
          ulFITExtractor();
      }
	var ulFITExtractorM = function() {
		$(".prodInfoAccordion #description-acc .prod_fit").insertAfter(".fit-insert-2");
	};
        if ($(".prod_fit")[0]) {
          	ulFITExtractorM();
      }

	// Repositions Filters on Desktop
	var filterMover = function() {
		$(".filters").insertAfter(".filter-after");
	};
	$(".accord-review:first-child").addClass("first-rating");
	//Make Spotlight SLider
	var slSlider = function() {
		$('.spotlight-slider').bxSlider({
			auto: 'true',
			slideMargin: '10',
			infiniteLoop: 'true',
			useCSS: 'false',  
			touchEnabled: false
		});
	};
	//slSlider();
	// Renames class to avoid desktop css
	var classRenamer = function() {
		$(".main-product-wrap").attr('class', 'main-product-wrap-mobile');
	};
	//Moves Add To Card Button
	var atcTeleport = function() {
		$( ".addToCartBtn" ).insertAfter( ".prod-info .clear" );	
	};
	// Pulls Description title out of accordion
	var descTitleExtractor = function() {
		$( ".description-title" ).insertAfter( ".stringing-options" );
	};
	// Repositions Options div
	var optionMover = function() {
		$( ".prod-options" ).insertAfter( ".pull-me-out" );
	};
	// Puts tabs in correct position for desktop
	var tabExtractor = function() {
		$( ".prodInfoAccordion .tabs" ).insertBefore( ".description-title" );
	};	
	$( "#mm-mainNav ul li:last-child a" ).addClass("top-lvl-services");
	//add recommended tension range to tension pick up tab
	
	//var prodMiniSpec = function() {
	//	var miniSpec = $('.prod_minispec').html();
	//	$('.mini-spec-wrap').append(miniSpec);
	//	// console.log(miniSpec);
	//};

	//if ($('#description').find('.prod_minispec').length) {
	//	prodMiniSpec();
    //  	$('.mini-spec-wrap').css("display", "inline-block");
	//} else {
	//	$('.mini-spec-wrap').css("display", "none");
	//}
	
	var ratingCloner = function() {
		//var prodRat = document.getElementsByClassName('spr-summary-starrating')[0].innerHTML;
		//document.getElementsByClassName('rating-wrap')[0].innerHTML = prodRat;      
	};
	if ($('.spr-summary-starrating').length) {
		ratingCloner();
	}
	
	// Mobile accordion: init after description/spec/fit/tech nodes are in final positions (avoids reflow/FOUC from jQuery UI).
	accordionMaker();

	$('.thumbs .image a img').click(function() {
		var newAlt = $(this).attr("alt");
      	var currTitle = document.getElementById("prod-title").innerText;
      	if (newAlt != currTitle) {
		$(".prod-pics .colour-display").text(newAlt);
        } else {
        $(".prod-pics .colour-display").text("");  
        }
	})

	// IE 9 ADDCLASS
	$("select").parent().addClass("selectParent");
  
  	// Repositions Reviews to Desktop
	var reviewMover = function() {
		$("#review-mover").insertBefore("#review-dtop");
	};
  	

	///////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////// Reverse Functions//////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////////////////
	
  	// Repositions Reviews to Mobile
	var r_reviewMover = function() {
		$("#review-mover").insertBefore("#review-mobile");
	};
  	// initializes Product Tabs and inserts Tab elements
	var accordionBreaker = function() {
		$('.tabs').insertAfter('.stringing-options');
		$('.prodInfoAccordion').accordion(motPdpAccordionOptions);
	};
	// Repositions Filters on Tablet and Mobile
	var r_filterMover = function() {
		$(".filters").insertAfter(".page-titler");
	};
	// Renames class to catch desktop css
	var r_classRenamer = function() {
		$(".main-product-wrap-mobile").attr('class', 'main-product-wrap');
	};
	var r_atcTeleport = function() {
		$( ".atc-wrap" ).append( $(".addToCartBtn") );
	};
	var r_descExtractor = function() {
		$( ".pull-me-out" ).insertAfter( ".prodInfoAccordion .pull-me-out-handle" );
	};
	var r_optionMover = function() {
		$( ".prod-options" ).insertAfter( ".prod-info" );
	};
	//Destroys Spotlight SLider
	var slSliderDestroyer = function() {
		slider = $('.spotlight').bxSlider();
		slider.destroySlider();
	};
  	//Close mmenu  	
  	
	var $window = $(window);
	var mqMin768 = typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 768px)') : null;
	function motIsMin768() {
		return mqMin768 ? mqMin768.matches : $window.width() >= 768;
	}
	var mqPdpTabs = typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 1024px)') : null;
	function motIsPdpTabsLayout() {
		return mqPdpTabs ? mqPdpTabs.matches : $window.width() >= 1024;
	}

	///////////////////////////////////////////////////////////////////////////////////////////////
	///////////////////// PDP: tabs 1024px+; accordion below (768 still drives other mobile UI) ///
	///////////////////////////////////////////////////////////////////////////////////////////////
	if (motIsPdpTabsLayout()){
		$( ".prodInfoTabs" ).tabs({
			show: false,
			hide: false
		});
		$( ".accordionSection" ).removeClass( "pull-me-out" );
      	reviewMover();
	} else {
		r_reviewMover();
	}

	if ($window.width() > 1240){
		//filterMover();
      	// Remove all anchors from to level navigation
		//$("#mainNav > .container > ul.horizontal > li.dropdown > a").attr({
		//	href: "",
		//	onclick: "return false"
		//});

		//$("body").click(function() {
		//    $('li.dropdown').removeClass("dd-active");
		//});

		//$(".dropdown-inner").click(function(e) {
		//    e.stopPropagation();
		//});

		//Initiate hover dropdown effect upon click and remove from hover
		//$('#mainNav16 > ul > li').on('click',function(e) {
			//e.stopPropagation();
			// console.log($(this).parent().hasClass('dd-active'));
			//if ($("ul.dropdown").hasClass("dd-active")) {
				//$("ul.dropdown").removeClass("dd-active");
				//$('ul.horizontal > li > a').removeClass("active-nav");
			//}
			
			//if($(this).parent().hasClass('dd-active')){
				//$('li.dropdown').removeClass("dd-active");
				
			//}
			//else{
				//$('li.dropdown').removeClass("dd-active");
				//$(this).parent().addClass("dd-active");

			//}
			// $(this).toggleClass("active-nav");
		//});

		//$("li.dropdown").on("click", function(event) {
			// event.preventDefault();
			// $(".dropdown").removeClass("dd-active");
		 // 	$(this).removeClass("active-nav");
		    // console.log("active");
		//});
	}

	///////////////////////////////////////////////////////////////////////////////////////////////
	///////////////////// Mobile Only/////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////////////////
	if (!motIsMin768()){
		classRenamer();
		//Mobile sidebar 
		$( ".sideBarNav .ll-title" ).click(function() {
			$(this).siblings("ul").slideToggle();
		});
	}
	///////////////////////////////////////////////////////////////////////////////////////////////
	///////////////////RESPONSIVE CONDITION////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////////////////
	function motOnCross768() {
		if (motIsMin768()) {
			r_classRenamer();
		} else {
			classRenamer();
		}
	}
	function motOnCrossPdpTabs() {
		if (motIsPdpTabsLayout()) {
			reviewMover();
			if ($('.prodInfoTabs').length) {
				$( ".prodInfoTabs" ).tabs({
					show: false,
					hide: false
				});
			}
			$( ".accordionSection" ).removeClass( "pull-me-out" );
		} else {
			r_reviewMover();
		}
	}
	if (mqMin768) {
		if (mqMin768.addEventListener) {
			mqMin768.addEventListener('change', motOnCross768);
		} else if (mqMin768.addListener) {
			mqMin768.addListener(motOnCross768);
		}
	} else {
		var lastMw = motIsMin768();
		$window.on('resize', function () {
			var now = motIsMin768();
			if (now !== lastMw) {
				lastMw = now;
				motOnCross768();
			}
		});
	}
	if (mqPdpTabs) {
		if (mqPdpTabs.addEventListener) {
			mqPdpTabs.addEventListener('change', motOnCrossPdpTabs);
		} else if (mqPdpTabs.addListener) {
			mqPdpTabs.addListener(motOnCrossPdpTabs);
		}
	} else {
		var lastPdp = motIsPdpTabsLayout();
		$window.on('resize', function () {
			var now = motIsPdpTabsLayout();
			if (now !== lastPdp) {
				lastPdp = now;
				motOnCrossPdpTabs();
			}
		});
	}

	/* Racquet PDP: minispec pills — scroll to tabs/specs header first, then open (short delay so scroll starts first). */
	$(document).on('click', '.racquet-minispec-pill', function (e) {
		e.preventDefault();
		var scrollFn = window.motScheduleScrollToBelowHeader;
		var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		var openAfterMs = reduced ? 0 : 50;

		var useTabs = motIsPdpTabsLayout();
		function openSpecs() {
			if (useTabs) {
				var $specLink = $('.prodInfoTabs a[href="#specifications"]');
				if ($specLink.length) {
					var $specLi = $specLink.closest('li');
					if (!$specLi.hasClass('ui-state-active')) {
						$specLink.trigger('click');
					}
				}
			} else {
				var $specHeader = $('.prodInfoAccordion > .accord-title.specifications-tab');
				if ($specHeader.length && !$specHeader.hasClass('ui-state-active')) {
					$specHeader.trigger('click');
				}
			}
		}

		if (typeof scrollFn !== 'function') {
			openSpecs();
			return;
		}

		if (useTabs) {
			var bar = document.querySelector('.prodInfoTabs ul.tabs');
			if (bar) scrollFn(bar, 0);
		} else {
			var headerEl = document.querySelector('.prodInfoAccordion > .accord-title.specifications-tab');
			if (headerEl) scrollFn(headerEl, 0);
		}
		setTimeout(openSpecs, openAfterMs);
	});
	$(document).on('keydown', '.racquet-minispec-pill', function (e) {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			$(this).trigger('click');
		}
	});

	/* PDP: Stamped reviews widgets inject after load — show loading, hide when content appears or show error after 10s */
	(function motPdpStampedReviewsAsyncStatus() {
		var status = document.getElementById('pdp-reviews-async-status');
		var stampedMain = document.getElementById('stamped-main-widget');
		if (!status || !stampedMain) return;

		var loadingEl = status.querySelector('.pdp-reviews-async-status__loading');
		var errorEl = status.querySelector('.pdp-reviews-async-status__error');
		var obs;
		var failTimer;
		var done = false;

		function widgetLooksLoaded(el) {
			if (!el) return false;
			if (el.querySelector('[class*="stamped"]')) return true;
			if (el.children.length > 0 && el.textContent && el.textContent.replace(/\s+/g, ' ').trim().length >= 12) {
				return true;
			}
			return false;
		}

		function markDone() {
			if (done) return;
			done = true;
			if (failTimer) clearTimeout(failTimer);
			if (obs) obs.disconnect();
			status.setAttribute('hidden', 'hidden');
			status.setAttribute('aria-hidden', 'true');
			status.setAttribute('aria-busy', 'false');
		}

		function markFailed() {
			if (done) return;
			done = true;
			if (failTimer) clearTimeout(failTimer);
			if (obs) obs.disconnect();
			if (loadingEl) loadingEl.setAttribute('hidden', 'hidden');
			if (errorEl) errorEl.removeAttribute('hidden');
			status.setAttribute('aria-busy', 'false');
		}

		function tick() {
			if (done) return;
			var w2 = document.getElementById('stamped-reviews-widget');
			if (widgetLooksLoaded(stampedMain) || widgetLooksLoaded(w2)) {
				markDone();
			}
		}

		obs = new MutationObserver(tick);
		obs.observe(stampedMain, { childList: true, subtree: true });
		var w2init = document.getElementById('stamped-reviews-widget');
		if (w2init) obs.observe(w2init, { childList: true, subtree: true });

		tick();
		failTimer = setTimeout(function () {
			tick();
			if (!done) markFailed();
		}, 10000);
	})();
})